const WHATSAPP_CELULAR_STORAGE_KEY = "whatsappCelular";

// Persiste o celular de origem de uma jornada iniciada a partir do ChatIA/OpenClick
// (retorno via WhatsApp, tela /login-whatsapp?celular=X) em sessionStorage. Segue o
// mesmo padrão já usado neste módulo para "redirectUrl" (LoginWhatsapp.js, Login.js,
// saga_usuario.js): sobrevive a navegações completas de página, inclusive o round-trip
// externo do Gov.br, permitindo propagar o celular por toda a jornada de login/
// criar-conta/recuperar-senha sem precisar repassá-lo via querystring ou state do
// React Router em cada rota intermediária.
export const setWhatsappCelular = (celular) => {
  if (celular) {
    sessionStorage.setItem(WHATSAPP_CELULAR_STORAGE_KEY, celular);
  }
};

export const getWhatsappCelular = () => {
  return sessionStorage.getItem(WHATSAPP_CELULAR_STORAGE_KEY) || null;
};

export const clearWhatsappCelular = () => {
  sessionStorage.removeItem(WHATSAPP_CELULAR_STORAGE_KEY);
};

const WHATSAPP_URL_RETORNO_STORAGE_KEY = "whatsappUrlRetornoAtendimento";

// Persiste a "url_retorno_atendimento" devolvida por POST /usuario/sessao (lida pelo
// backend da configuração whatsapp.atendimento.url) para a tela de sucesso
// (LoginWhatsappSucesso.js) usar no botão "Voltar ao WhatsApp" — o valor só existe
// depois da vinculação, então precisa sobreviver ao redirect que acontece na sequência.
export const setWhatsappUrlRetorno = (url) => {
  if (url) {
    sessionStorage.setItem(WHATSAPP_URL_RETORNO_STORAGE_KEY, url);
  }
};

export const getWhatsappUrlRetorno = () => {
  return sessionStorage.getItem(WHATSAPP_URL_RETORNO_STORAGE_KEY) || null;
};

export const clearWhatsappUrlRetorno = () => {
  sessionStorage.removeItem(WHATSAPP_URL_RETORNO_STORAGE_KEY);
};
